export default __webpack_public_path__ + "static/media/640_dummy2016-beauty01-mobile-de.73d34315.png";